import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt, faIdBadge } from '@fortawesome/free-solid-svg-icons';

// Usage: <MiniERPMyCodeShare code={myCode} name={myName} />
const MiniERPMyCodeShare = ({ code, name, className = '' }) => {
  if (!code) return null;

  const shareText = `Hi! Add me on Think5Whys MiniERP to do business transactions — my code is ${code}${name ? ` (${name})` : ''}.`;

  return (
    <div className={`flex items-center gap-2 text-xs ${className}`}>
      <FontAwesomeIcon icon={faIdBadge} className="text-gray-500" />
      <span className="text-gray-400">Your code:</span>
      <span className="font-mono text-cyan-300">{code}</span>
      <button
        type="button"
        onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank')}
        className="w-fit px-1.5 py-1.5 rounded-lg bg-gray-700 hover:bg-emerald-600 text-gray-300 hover:text-white transition-colors"
        title="Share your code via WhatsApp"
      >
        <FontAwesomeIcon icon={faShareAlt} />
      </button>
    </div>
  );
};

export default MiniERPMyCodeShare;
